/* SAMPLE COLLECTORS */
export const GET_REFERREL_FEES = "GET_REFERREL_FEES";
export const GET_REFERREL_FEES_SUCCESS =
  "GET_REFERREL_FEES_SUCCESS";
export const GET_REFERREL_FEES_FAIL = "GET_REFERREL_FEES_FAIL";

export const GET_PUT_REFERREL_FEES = "GET_PUT_REFERREL_FEES";
export const GET_PUT_REFERREL_FEES_SUCCESS =
  "GET_PUT_REFERREL_FEES_SUCCESS";
export const GET_PUT_REFERREL_FEES_FAIL = "GET_PUT_REFERREL_FEES_FAIL";

export const UPDATE_REFERREL_FEE = "UPDATE_REFERREL_FEE";
export const UPDATE_REFERREL_FEE_SUCCESS =
  "UPDATE_REFERREL_FEE_SUCCESS";
export const UPDATE_REFERREL_FEE_FAIL =
  "UPDATE_REFERREL_FEE_FAIL";

export const UPDATE_REFERREL_ALL_FEE = "UPDATE_REFERREL_ALL_FEE";
export const UPDATE_REFERREL_ALL_FEE_SUCCESS =
  "UPDATE_REFERREL_ALL_FEE_SUCCESS";
export const UPDATE_REFERREL_ALL_FEE_FAIL =
  "UPDATE_REFERREL_ALL_FEE_FAIL";
